import {
  FC,
  PropsWithChildren,
  RefObject,
  useLayoutEffect,
  useState,
} from 'react';

import { createPortal } from 'react-dom';

type CustomPortalProps = {
  containerRef: RefObject<HTMLDivElement>;
} & PropsWithChildren;

export const CustomPortal: FC<CustomPortalProps> = ({
  containerRef,
  children,
}) => {
  const [portalContainer, setPortalContainer] = useState<HTMLDivElement | null>(
    null,
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useLayoutEffect(() => {
    setPortalContainer(containerRef.current);
  });

  return portalContainer && createPortal(children, portalContainer);
};
